export function initILiveBlog() {
  if (document.getElementsByClassName('arena-embed') !== undefined) {
    window.addEventListener('message', function(event) {
      if (event.data && event.data.source === 'lb24-auto-size') {
        let blogFrame = document.getElementsByClassName('arena-embed')
        blogFrame[0].style.height = event.data.height + 'px'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/liveBlog/initLiveBlog.js